export default __webpack_public_path__ + "static/media/Juggling act 1.7139b5a2.jpg";